import {
  Heading,
  Link,
  ListItem,
  ListUnordered,
  Paragraph,
} from "@digdir/designsystemet-react";
import { ExternalLinkIcon } from "@navikt/aksel-icons";
import { useTranslation } from "react-i18next";
import { Page } from "@/components";
import { DokumentasjonsLenker } from "../dokumentasjon/DokumentasjonsLenker";
import { NyttigeLenkerList } from "../shared/NyttigeLenker";

export const KundestøttePage = () => {
  const { t } = useTranslation();
  return (
    <main className="container mx-auto grid grid-cols-1 xl:grid-cols-[1fr_auto] py-14 gap-6 gap-x-12 max-w-page">
      <Page withBackLink>
        <div className="flex flex-col xl:flex-row gap-12">
          <div className="flex flex-col gap-10 max-w-4xl! mx-0">
            <Heading level={1} data-size="xl" className="mb-6">
              {t("pages.kundestotte.tittel")}
            </Heading>

            <section className="flex flex-col gap-4">
              <Heading level={2} data-size="sm">
                {t("pages.kundestotte.veiledning.tittel")}
              </Heading>
              <Paragraph>
                {t("pages.kundestotte.veiledning.beskrivelse")}
              </Paragraph>
              <ListUnordered className="list-none pl-0 space-y-4">
                <ListItem>
                  <Link
                    href={t("eksterneLenker.veiledning.url")}
                    data-size={"sm"}
                  >
                    {t("pages.kundestotte.veiledning.lenke")}
                    <ExternalLinkIcon
                      fontSize={"1.5rem"}
                      className="pl-1"
                      aria-hidden
                    />
                  </Link>
                </ListItem>
              </ListUnordered>
            </section>

            <section className="flex flex-col gap-4">
              <Heading level={2} data-size="sm">
                {t("pages.kundestotte.spoersmaal-om-regelverk.tittel")}
              </Heading>
              <Paragraph>
                {t("pages.kundestotte.spoersmaal-om-regelverk.beskrivelse")}
              </Paragraph>
              <ListUnordered className="list-none pl-0 space-y-4">
                <ListItem>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    href={t("eksterneLenker.merOmNorgespris.url")}
                    data-size={"sm"}
                  >
                    {t(
                      "pages.kundestotte.spoersmaal-om-regelverk.lenke-om-norgespris",
                    )}
                    <ExternalLinkIcon
                      fontSize={"1.5rem"}
                      className="pl-1"
                      aria-hidden
                    />
                  </Link>
                </ListItem>

                <ListItem>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    href={t("eksterneLenker.spmOgSvarNve.url")}
                    data-size={"sm"}
                  >
                    {t(
                      "pages.kundestotte.spoersmaal-om-regelverk.lenke-mer-om-regelverket",
                    )}
                    <ExternalLinkIcon
                      fontSize={"1.5rem"}
                      className="pl-1"
                      aria-hidden
                    />
                  </Link>
                </ListItem>
              </ListUnordered>
            </section>

            <section className="flex flex-col gap-4">
              <Heading level={2} data-size="sm">
                {t("pages.kundestotte.spoersmaal-om-loesning.tittel")}
              </Heading>
              <Paragraph>
                {t("pages.kundestotte.spoersmaal-om-loesning.beskrivelse")}
              </Paragraph>
              <ListUnordered className="list-none pl-0 space-y-4">
                <ListItem>
                  <Link
                    target="_blank"
                    rel="noreferrer"
                    href={t("eksterneLenker.enovaSvarer.url")}
                    data-size={"sm"}
                  >
                    {t(
                      "pages.kundestotte.spoersmaal-om-loesning.lenke-kontakt-oss",
                    )}
                    <ExternalLinkIcon
                      fontSize={"1.5rem"}
                      className="pl-1"
                      aria-hidden
                    />
                  </Link>
                </ListItem>
              </ListUnordered>
            </section>
          </div>
          <section className="mt-4 space-y-8 xl:self-top-end">
            <DokumentasjonsLenker className="w-full!" />
            <NyttigeLenkerList isFaqPage />
          </section>
        </div>
      </Page>
    </main>
  );
};
